import { Dispatch } from 'react';
import { CLEAR_STATE, IClearState } from 'src/contexts/types';
/**
 * Will clear the state to default values
 *
 * @param {Dispatch<IClearState>} dispatch Function that update state
 * @param {T} initialState Initial state
 */
export const clearState = async <T>(
    dispatch: Dispatch<IClearState>,
    initialState: T
) => dispatch({ type: CLEAR_STATE, payload: initialState });
